import { computed as B, createBlock as w, createCommentVNode as x, unref as o, openBlock as L, withCtx as t, createVNode as d, withModifiers as p, createTextVNode as r, createElementVNode as l, toDisplayString as m } from "vue";
import { BModal as V, BButton as c } from "bootstrap-vue-next";
import { u as _ } from "../composables/useLogoutPrompt.DPprRGah.js";
const P = { "data-dd-privacy": "mask" }, I = {
  __name: "IdleLogoutPrompt",
  props: {
    // we inject the logout handler composable as a prop so we can mock it in tests
    // but provide a default implementation so consumers don't have to pass it
    handler: {
      type: Function,
      default: _
    }
  },
  setup(g) {
    const f = g, { user: n, showLogoutPrompt: v, secondsRemaining: k, logout: y, cancel: N } = f.handler(), C = B(
      () => {
        var a, e, s, u, i;
        return `${((e = (a = n.value) == null ? void 0 : a.profile) == null ? void 0 : e.firstName) ?? ""} ${((u = (s = n.value) == null ? void 0 : s.profile) == null ? void 0 : u.lastName) ?? ((i = n.value) == null ? void 0 : i.email)}`;
      }
    );
    return (a, e) => o(v) ? (L(), w(o(V), {
      key: 0,
      id: "logout-prompt",
      title: "Automatic Logout",
      "model-value": !0,
      "no-header-close": !0,
      "no-close-on-esc": !0,
      "no-close-on-backdrop": !0,
      "header-variant": "secondary"
    }, {
      default: t(() => [
        l("p", null, [
          e[0] || (e[0] = r(" You are currently logged in as ")),
          l("strong", P, m(C.value), 1),
          e[1] || (e[1] = r(". "))
        ]),
        l("p", null, " You will be automatically logged out in " + m(o(k)) + " seconds. ", 1)
      ]),
      ok: t(() => [
        d(o(c), {
          variant: "primary",
          onClick: p(o(y), ["prevent"])
        }, {
          default: t(() => e[2] || (e[2] = [
            r(" Yes, sign in as another user ")
          ])),
          _: 1
        }, 8, ["onClick"])
      ]),
      cancel: t(() => [
        d(o(c), {
          variant: "secondary",
          onClick: p(o(N), ["prevent"])
        }, {
          default: t(() => e[3] || (e[3] = [
            r(" No, stay signed in ")
          ])),
          _: 1
        }, 8, ["onClick"])
      ]),
      _: 1
    })) : x("", !0);
  }
};
export {
  I as _
};
